/**
 * @hidden
 */
export var focusFirstFocusableChild = function (element) {
    if (element) {
        // should focus wrapper if it's focusable in future versions
        var elements = element.querySelectorAll('input, [tabindex]:not([tabindex="-1"])');
        if (elements.length && elements[0].focus) {
            elements[0].focus();
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-common/dist/es/focus.js
// module id = 780
// module chunks = 93